































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import ScheduledFeesCreateDialog from '@/components/Products/ProductFees/Scheduled/ScheduledFeesCreateDialog.vue';
import ScheduledFeesEditDialog from '@/components/Products/ProductFees/Scheduled/ScheduledFeesEditDialog.vue';
import ScheduledFeesDeleteDialog from '@/components/Products/ProductFees/Scheduled/ScheduledFeesDeleteDialog.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import { ProductIssueDetailsModule } from '@/store/Products/ProductIssueDetailsModule';
import EntityType from '@/models/Shared/EntityType';
import ScheduledFee from '@/models/Products/ProductFees/ScheduledFee';
import PeriodType from '@/models/Shared/PeriodType';

@Component({ name: 'ScheduledFees', components: { ScheduledFeesCreateDialog, ScheduledFeesEditDialog, ScheduledFeesDeleteDialog } })
export default class extends SaascadaVue {

    EntityType = EntityType;
    PeriodType = PeriodType;
    headers = [
        { text: this.$t('pageText.products.fields.name'), width: "100%" }
    ];
    scheduledFeesPage = 1;

    @Prop({required: true})
    entityType: EntityType;

    @Watch('scheduledFeesPage')
    async onScheduledFeesPageChanged() {
        // Preselect the first row on the next page
        // NOTE: This is only needed when paginating locally through results
        const nextItemIndex = (this.scheduledFeesPage - 1) * this.pageSize;
        const nextItem = this.scheduledFees[nextItemIndex];
        await ProductDetailsModule.updateCurrentScheduledFee(nextItem);
    }

    async updateCurrentScheduledFee(scheduledFee: ScheduledFee) {
        await ProductDetailsModule.updateCurrentScheduledFee(scheduledFee);
    }

    get currentScheduledFee() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.currentScheduledFee;
        }
        return ProductIssueDetailsModule.currentScheduledFee;
    }

    get scheduledFees() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.product.generalFeeSettings.scheduledFees;
        }
        return ProductIssueDetailsModule.productIssue.generalFeeSettings.scheduledFees;
    }

    get totalScheduledFeesPages() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.totalScheduledFeesPages;
        }
        return ProductIssueDetailsModule.totalScheduledFeesPages;
    }

    get loading() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.loading;
        }
        return ProductIssueDetailsModule.loading;
    }

    get pageSize() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.pageSize;
        }
        return ProductIssueDetailsModule.pageSize;
    }

}
